"use client"

interface Subject {
  name: string
  type: "Compulsory" | "Optional"
}

interface GradeLevel {
  level: string
  subjects: Subject[]
}

interface LearningJourneyProps {
  gradeLevels: GradeLevel[]
}

export function LearningJourney({ gradeLevels }: LearningJourneyProps) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="text-base">🎓</span>
        <h2 className="text-base font-bold text-slate-900">Learning Journey</h2>
        <span className="ml-auto text-xs text-slate-400">{gradeLevels.length} stages</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {gradeLevels.map((grade) => (
          <div key={grade.level} className="bg-slate-50 border border-slate-100 rounded-xl p-3">
            <h3 className="font-semibold text-sm text-slate-700 mb-2">{grade.level}</h3>
            <div className="space-y-1.5">
              {grade.subjects.map((subject) => (
                <div key={subject.name} className="flex items-center justify-between gap-2">
                  <span className="text-xs text-slate-600 truncate">{subject.name}</span>
                  <span
                    className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full shrink-0 ${
                      subject.type === "Compulsory"
                        ? "bg-emerald-100 text-emerald-700"
                        : "bg-amber-100 text-amber-700"
                    }`}
                  >
                    {subject.type === "Compulsory" ? "Core" : "Opt"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
